import { GRAPHQL_CUSTOMER_AGENT_QUERIES } from 'graphql/customer-agent'
import type {
  TCustomerAgentQueriesData,
  TCustomerAgentQueriesName,
  TCustomerAgentQueriesVariables,
} from 'graphql/customer-agent/types'
import { buildQueryHook } from 'lib/apollo-client/builders'

export const useCustomerAgentQueries = buildQueryHook<
  TCustomerAgentQueriesName,
  TCustomerAgentQueriesVariables,
  TCustomerAgentQueriesData
>(GRAPHQL_CUSTOMER_AGENT_QUERIES)
